import 'rc-notification/assets/index.css';

import { GenericIcon } from 'vrlcm-gui-components';
import Notification from 'rc-notification';
import React from 'react';

let notificationInstance: any = null;

const transitionName = 'move-up';

let runningNumber = 0;

type ToastType = 'info' | 'success' | 'warning' | 'danger' | 'loading';

interface ToastConfig {
  closable?: boolean;
  duration?: number | null; // ms
  createdOn?: Date;
}

function getNotificationInstance(callback: (i: any) => void) {
  if (notificationInstance) {
    callback(notificationInstance);
  } else {
    Notification.newInstance(
      {
        transitionName
      },
      (n: any) => {
        notificationInstance = n;
        callback(n);
      }
    );
  }
}

const ToastRenderer = (props: {
  message: string;
  type: ToastType;
  createdOn: Date;
  close?: () => void;
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ marginRight: '9px' }}>
        <GenericIcon solid={true} type={props.type} size={27} />
      </div>
      <span style={{ fontSize: '0.625rem', color: '#313131' }}>
        {props.message}
      </span>
    </div>
  );
};

function closeNotification(key: number) {
  getNotificationInstance(notification => notification.removeNotice(key));
}

function createNotification(
  message: string,
  type: ToastType,
  config?: ToastConfig
) {
  const key = runningNumber++;
  const closable =
    config && config.closable !== undefined ? config.closable : undefined;
  const duration =
    config && config.duration !== undefined ? config.duration : undefined;
  const createdOn = config && config.createdOn ? config.createdOn : new Date();

  getNotificationInstance(notification => {
    notification.notice({
      key,
      content: (
        <ToastRenderer
          type={type}
          message={message}
          createdOn={createdOn}
          close={closeNotification.bind(null, key)}
        />
      ),
      duration,
      closable
    });
  });
}

function removeOtherNotifications() {
  if (runningNumber > 0) {
    getNotificationInstance(notification => {
      const allNotices = notification.component.state.notices;
      allNotices.forEach((notice: any) => {
        notification.removeNotice(notice.key);
      });
      runningNumber = 0;
    });
  }
}

interface ToastApi {
  configure: (opts: {}) => void;
  info: (message: string, config?: ToastConfig) => void;
  warn: (message: string, config?: ToastConfig) => void;
  error: (message: string, config?: ToastConfig) => void;
  success: (message: string, config?: ToastConfig) => void;
  loading: (message: string, config?: ToastConfig) => void;
  removeOthers: () => void;
}

const toast: ToastApi = {
  configure: (opts: {}) => {
    // TODO
  },
  info: (message: string, config?: ToastConfig) =>
    createNotification(message, 'info', config),
  warn: (message: string, config?: ToastConfig) =>
    createNotification(message, 'warning', config),
  error: (message: string, config?: ToastConfig) =>
    createNotification(message, 'danger', config),
  loading: (message: string, config?: ToastConfig) =>
    createNotification(message, 'loading', config),
  success: (message: string, config?: ToastConfig) =>
    createNotification(message, 'success', config),
  removeOthers: () => removeOtherNotifications()
};

export default toast;
